import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';
export let ELumaBotQuestionType;
(function (ELumaBotQuestionType) {
  ELumaBotQuestionType["Address"] = "address";
  ELumaBotQuestionType["TDate"] = "date";
  ELumaBotQuestionType["Dropdown"] = "dropdown";
  ELumaBotQuestionType["Email"] = "email";
  ELumaBotQuestionType["Jump"] = "jump";
  ELumaBotQuestionType["LongText"] = "long_text";
  ELumaBotQuestionType["ManageAppointment"] = "manage_appointment";
  ELumaBotQuestionType["MedicationSearch"] = "medication_search";
  ELumaBotQuestionType["MultipleChoice"] = "multiple_choice";
  ELumaBotQuestionType["PharmacySearch"] = "pharmacy_search";
  ELumaBotQuestionType["PhoneNumber"] = "phone_number";
  ELumaBotQuestionType["Scheduler"] = "scheduler";
  ELumaBotQuestionType["ShortText"] = "short_text";
  ELumaBotQuestionType["SSN"] = "ssn";
  ELumaBotQuestionType["Template"] = "template";
  ELumaBotQuestionType["TemplateWelcome"] = "template_welcome";
  ELumaBotQuestionType["TwoFA"] = "2FA";
  ELumaBotQuestionType["YesNo"] = "yes_no";
  ELumaBotQuestionType["ZipCode"] = "zipcode";
})(ELumaBotQuestionType || (ELumaBotQuestionType = {}));
export let ELumaBotFlowTemplateSource;
(function (ELumaBotFlowTemplateSource) {
  ELumaBotFlowTemplateSource["System"] = "system";
  ELumaBotFlowTemplateSource["User"] = "user";
})(ELumaBotFlowTemplateSource || (ELumaBotFlowTemplateSource = {}));
export let ELumaBotFlowType;
(function (ELumaBotFlowType) {
  ELumaBotFlowType["Welcome"] = "welcome";
  ELumaBotFlowType["AuthenticatePatient"] = "authenticate-patient";
  ELumaBotFlowType["SpeakWithStaff"] = "speak-with-staff";
  ELumaBotFlowType["SessionTimeout"] = "session-timeout";
  ELumaBotFlowType["KnockKnock"] = "knock-knock";
  ELumaBotFlowType["CulDeSac"] = "cul-de-sac";
  ELumaBotFlowType["Feedback"] = "feedback";
  ELumaBotFlowType["Regular"] = "regular";
})(ELumaBotFlowType || (ELumaBotFlowType = {}));
export let ELumaBotTemplateItemRedirectType;
(function (ELumaBotTemplateItemRedirectType) {
  ELumaBotTemplateItemRedirectType["None"] = "none";
  ELumaBotTemplateItemRedirectType["GoTo"] = "goTo";
  ELumaBotTemplateItemRedirectType["GoToForm"] = "goToForm";
  ELumaBotTemplateItemRedirectType["GoToPrevious"] = "goToPrevious";
  ELumaBotTemplateItemRedirectType["IsFinal"] = "isFinal";
})(ELumaBotTemplateItemRedirectType || (ELumaBotTemplateItemRedirectType = {}));
export const fieldsLumaBotFlowTemplate = _extends({}, fieldsIBaseModelWithUser, {
  active: {
    type: 'Boolean'
  },
  description: {
    type: 'Text'
  },
  facilities: {
    type: 'ID',
    ref: EModel.Facility,
    array: true
  },
  flowType: {
    type: 'Option',
    values: ELumaBotFlowType
  },
  notifyStaffOnComplete: {
    type: 'Boolean'
  },
  readonly: {
    type: 'Boolean'
  },
  schedulerRequestInterceptor: {
    type: 'Text'
  },
  schedulerResponseInterceptor: {
    type: 'Text'
  },
  sendToHubOnComplete: {
    type: 'Boolean'
  },
  source: {
    type: 'Option',
    values: ELumaBotFlowTemplateSource
  },
  tag: {
    type: 'Text'
  },
  template: {
    type: 'Object'
  },
  title: {
    type: 'Text'
  },
  url: {
    type: 'Text'
  }
});